define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"./_ApproveBOMMixin"
], function(declare,Controller,_ApproveBOMMixin) {

	return declare([Controller, _ApproveBOMMixin], {
		onRefreshValidation: function() {
			// summary: refresh view after validation
			this.widget.redrawNode(this.m_element);
		}
	});
});